<div *transloco="let fieldTranslation; read: 'field-types'" class="flex flex-col items-center">
  <div
    class="bg-card w-60 h-60 rounded-full border border-dashed flex items-center place-content-center justify-center p-4"
  >
    <div class="flex flex-col items-center place-content-center space-y-4">
      <div class="flex flex-col space-y-2 items-center place-content-center">
        <mat-icon class="w-20 h-20 text-accent" svgIcon="mat_outline:upload_file"></mat-icon>
        <span>{{ fieldTranslation("Drag up to", { maxNumberOfFiles: fileUploaderField.maxNumberOfFiles }) }} </span>
      </div>

      <span class="text-md text-center text-gray-500">{{ fieldTranslation("Select files") }}</span>
    </div>
  </div>
</div>
